import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import jaLocale from '@fullcalendar/core/locales/ja';


/*
 *
 * ----------------------------------------------- */
function fullcalendar(options) {
  var calendarEl = document.getElementById(options.id);
  var $calendar_modal = $('#calendar-modal');
  var $calendar_modal_btn_apply = $calendar_modal.find("[data-btn-apply]");

  if (options.events.length === 0) {
    $(calendarEl).text("まだ予定がありません。");

    return false;
  }

  var calendar = new Calendar(calendarEl, {
    height: 'auto',
    plugins: [dayGridPlugin],
    timeZone: 'local',
    locale: jaLocale,
    displayEventTime: false,
    eventTimeFormat: {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    },
    initialDate: options.initialDate,

    // events: [
    //   {
    //     // id: 'a',
    //     // title: 'my event',
    //     start: '2020-09-21'
    //   }
    // ],
    events: options.events,
    eventClick: function (info) {
      // alert('Event: ' + info.event.title);
      // alert('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
      // alert('View: ' + info.view.type);

      // change the border color just for fun
      // info.el.style.borderColor = 'red';

      // location.href = info.event.extendedProps;

      var $calendar = $("#" + options.id);
      var $currentEl = $(info.el);

      if (!$currentEl.hasClass("active") && 2 <= $calendar.find(".active").length) {
        alert("最大2つまで選択可能です。");
        return false;
      } else {
        if (!$currentEl.hasClass("active")) {
          $currentEl.attr("data-type", info.event.extendedProps.type);
          $currentEl.attr("data-pj_id", info.event.extendedProps.pj_id);
          $currentEl.attr("data-datetime", info.event.extendedProps.datetime);
          $currentEl.attr("data-pj_title", info.event.extendedProps.pj_title);
          $currentEl.attr("data-start_ja", info.event.extendedProps.start_ja);

          $calendar_modal.modal();
        }
      }

      $currentEl.toggleClass("active");

      var active_events = $calendar.find(".active");
      var $projects = $calendar_modal.find("[data-project]");
      $projects.hide();

      var $hidden_fields = $calendar_modal.find("[data-hidden-fields]");
      $hidden_fields.empty();

      $.each(active_events, function (i, val) {
        $($projects[i]).find("[data-pj_title]").text($(val).attr("data-pj_title"));
        $($projects[i]).find("[data-start_ja]").text($(val).attr("data-start_ja"));
        $($projects[i]).show();

        var $type = $("<input type='hidden' name='pj[" + i + "][type]'>").val($(val).attr("data-type"));
        var $pj_id = $("<input type='hidden' name='pj[" + i + "][pj_id]'>").val($(val).attr("data-pj_id"));
        var $datetime = $("<input type='hidden' name='pj[" + i + "][datetime]'>").val($(val).attr("data-datetime"));
        var $pj_title = $("<input type='hidden' name='pj[" + i + "][pj_title]'>").val($(val).attr("data-pj_title"));
        var $start_ja = $("<input type='hidden' name='pj[" + i + "][start_ja]'>").val($(val).attr("data-start_ja"));

        $hidden_fields.append($type);
        $hidden_fields.append($pj_id);
        $hidden_fields.append($datetime);
        $hidden_fields.append($pj_title);
        $hidden_fields.append($start_ja);
      });

      // console.log(info.event.extendedProps.applyLink);
    },
  });

  calendar.render();

  $("[href='#" + options.id + "']").on("shown.bs.tab", function (e) {
    calendar.render();
  });
}


/*
 *
 * ----------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  if (typeof event_fullcalendar !== "undefined") {
    fullcalendar(event_fullcalendar);
  }

  if (typeof web_fullcalendar !== "undefined") {
    fullcalendar(web_fullcalendar);
  }
});
